import type { LinkOptions } from '@tanstack/react-router'

import { URL_DASHBOARD } from '@/core/constants/constants'
import { FEATURE_STARTING_PAGE } from '@/core/constants/features'
import {
  DEFAULT_STARTING_PAGE,
  isStartingPage,
} from '@/core/constants/startingPage'
import type { StartingPage } from '@/core/constants/startingPage'

export function shouldApplyStartingPageRedirect({
  features,
  isFreshLogin,
  pathname,
}: {
  features: string[]
  isFreshLogin: boolean
  pathname: string
}) {
  return (
    isFreshLogin &&
    pathname === URL_DASHBOARD &&
    features.includes(FEATURE_STARTING_PAGE)
  )
}

export function resolveStartingPage(
  userStartingPage: unknown,
  companyStartingPage: unknown,
): StartingPage {
  if (isStartingPage(userStartingPage)) {
    return userStartingPage
  }

  return isStartingPage(companyStartingPage)
    ? companyStartingPage
    : DEFAULT_STARTING_PAGE
}

type RedirectStartingPage = Exclude<StartingPage, 'homepage'>

const STARTING_PAGE_LINKS = {
  'company-courses': { to: '/company-courses' },
  'exclusive-content': { to: '/exclusive-content' },
  'learning-paths-active': {
    to: '/learnpaths',
    search: { state: 'active' },
  },
  'learning-paths-all': { to: '/learnpaths' },
  'learning-paths-mandatory': {
    to: '/learnpaths',
    search: { types: ['mandatory'] },
  },
  'discovery-page': { to: '/discover' },
} satisfies Record<RedirectStartingPage, LinkOptions>

export function getStartingPageRedirect(page: StartingPage) {
  return page === 'homepage' ? null : STARTING_PAGE_LINKS[page]
}
